import { useEffect, useState } from "react";
import Pagination from "../Pagination";

const SearchOrgDialog = ({ onClose, onSelect, OrgTree }) => {

    const [search, setSearch] = useState("");
    const [list, setList] = useState(() =>
        OrgTree.filter((item) => item.id !== null)
    );
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const itemsPerPage = 10;

    const handleSelect = (item) => {
        onSelect(item);
        onClose();
    };

    function handleOnSearch() {
    
        const searchedList = OrgTree.filter((item) =>
            item.name.includes(search)
        );
        setList(searchedList);
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
        <div className="bg-white rounded-md p-6 w-[800px]">
            <div className="flex gap-2 mb-4">
                <input
                    type="text"
                    placeholder="검색어 입력"
                    value={search}
                    className="border p-2 flex-1"
                    onChange={(e) => {
                        setSearch(e.target.value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleOnSearch();
                        }
                    }}
                />
                <button 
                    className="bg-black text-white px-4 py-2 rounded"
                    onClick={() => handleOnSearch() }
                >검색</button>
            </div>

            <table className="w-full border text-sm text-center">
            <thead className="bg-gray-800 text-white">
                <tr>
                <th>NO</th>
                <th>조직 구분</th>
                <th></th>
                </tr>
            </thead>
            <tbody>
                {list
                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                .map((item, idx) => (
                <tr key={item.id} className="border-b">
                    <td>{(idx+1) + (currentPage-1)*itemsPerPage}</td>
                    <td className="text-left">{item.name}</td>
                    <td>
                        <button
                            onClick={() => handleSelect(item)}
                            className="bg-gray-300 px-2 py-1 rounded"
                        >
                            선택
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>

            <Pagination
                onChangeCurrentPage={(val) => setCurrentPage(val)}
                onChangeTotalPages={(val) => setTotalPages(val)}
                itemsPerPage={itemsPerPage}
                totalCount={list.length}
            />

            <div className="mt-4 text-center">
            <button onClick={onClose} className="bg-gray-600 text-white px-4 py-2 rounded">
                닫기
            </button>
            </div>
        </div>
        </div>
    );
};

export default SearchOrgDialog;